import { render, staticRenderFns } from "./MedicalGuide.vue?vue&type=template&id=26549216&scoped=true"
import script from "./MedicalGuide.vue?vue&type=script&lang=js"
export * from "./MedicalGuide.vue?vue&type=script&lang=js"
import style0 from "./MedicalGuide.vue?vue&type=style&index=0&id=26549216&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26549216",
  null
  
)

export default component.exports